import React from 'react'

import './circle-slider.scss'

import LeftIco from '../../../f/svg/left.svg'
import RightIco from '../../../f/svg/right.svg'

const AnonsSliderRu = ({ items = [] }) => {

    const itemsRef = React.useRef([])
    const slider = React.useRef(null)
    const currentIndex = React.useRef(0)

    const bounceIndex = (value, max) => {
        return (value % max + max) % max
    }

    const updateClasses = () => {
        const length = itemsRef.current.length

        if (!length)
        {
            return
        }

        const a = bounceIndex(currentIndex.current, length)
        const l = bounceIndex(currentIndex.current - 1, length)
        const pl = bounceIndex(currentIndex.current - 2, length)
        const r = bounceIndex(currentIndex.current + 1, length)
        const pr = bounceIndex(currentIndex.current + 2, length)

        itemsRef.current.forEach((item, index, arr) => {

            if (!item)
            {
                return
            }

            item.classList.toggle('active', index === a)
            item.classList.toggle('left', index === l)
            item.classList.toggle('prev-left', index === pl && arr.length > 3)
            item.classList.toggle('right', index === r)
            item.classList.toggle('prev-right', index === pr && arr.length > 3)
        })
    }

    const slide = direction => {
        currentIndex.current += direction
        updateClasses()
    }

    React.useEffect(() => {

        currentIndex.current = Math.floor(items.length / 2)

        updateClasses()

    }, [items])

    return (
        <>
            <div className='slider-circle' ref={slider} id='circle-slider'>

                {items.length > 3 && (
                    <div className='arrow left' onClick={() => slide(-1)}>
                        <img src={LeftIco} alt='' />
                    </div>
                )}

                {items.length > 3 && (
                    <div className='arrow right' onClick={() => slide(1)}>
                        <img src={RightIco} alt='' />
                    </div>
                )}

                {items.map((item, index) => (
                    <a
                        key={item.id || item.link || index}
                        href={item.link}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <div
                            className='circle-item'
                            ref={el => itemsRef.current[index] = el}
                        >
                            <div
                                className={`circle-image-wrapper ${item.bg ? 'cover-fit' : ''}`}
                                style={{
                                    '--bg': item.bg || ''
                                }}
                            >
                                <div
                                    className='circle-image'
                                    style={{
                                        backgroundImage: `url(${item.image})`
                                    }}
                                />
                            </div>

                            <img
                                className='circle-svg-text'
                                src={item.textSVG}
                                alt=''
                            />
                        </div>
                    </a>
                ))}

            </div>
        </>
    )
}

export default AnonsSliderRu